import {
  Backdrop, Button, Card, CardActions, createMuiTheme, CardContent, CardHeader, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogTitle, Divider,
  FormControl, Grid, InputAdornment, LinearProgress, Slide, Snackbar, Select
  , Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography
} from '@material-ui/core';
import { SearchIcon } from '@material-ui/data-grid';
import CloseIcon from '@material-ui/icons/Close';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import MuiAlert from '@material-ui/lab/Alert';
import trLocale from 'date-fns/locale/tr';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import clsx from 'clsx';
import React, { useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import GenericBulten from 'src/components/GenericBulletin';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import {
  getUser,
  sc,

} from 'src/utils/Common';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  cardUstBolum: {
    maxHeight: 700,
    minHeight: 700,
    width: '100%'
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  container: {
    maxHeight: 497,
    minHeight: 497,
    mimWidth: 500
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  rootAdresSearch: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(0)
  },
}));

const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});
const localeMap = {
  tr: trLocale
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function StateOfInactivity() {
  const classes = useStyles();
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();


  const [ImageUrl, setImageUrl] = useState(null);
  const [Loading, setLoading] = useState(false);
  const SessionUser = getUser();
  const [SayimData, setSayimData] = useState([]);
  const [SayimDataMain, setSayimDataMain] = useState([]);
  const [SayimArama, setSayimArama] = React.useState("");
  const [Neden, setNeden] = useState(365);
  const [BirimFiyatToplam, setBirimFiyatToplam] = React.useState(0);
  const [ToplamFiyatToplam, setToplamFiyatToplam] = React.useState(0);

  const handleNedenChange = (event) => {
    var index = event.target.selectedIndex;
    // setNedenAciklama(event.target[index].text);
    setNeden(event.target.value);
  };


  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };


  function onSorgula() {
    setLoading(true);
    axios
      .get(
        `/GetStateOfInactivity/${SessionUser.ServiceShopId}/${Neden}/`
      )
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          setSayimData(response.data);
          setSayimDataMain(response.data);
          var BirimFiyatToplam1 = (response.data.reduce((a, v) => a = a + v.KDVLI_FIYAT, 0));
          var ToplamFiyatToplam1 = (response.data.reduce((a, v) => a = a + v.TOPLAM_FIYAT, 0));
          setBirimFiyatToplam(BirimFiyatToplam1);
          setToplamFiyatToplam(ToplamFiyatToplam1);
        } else {
          setSayimData([]);
          setSayimDataMain([]);
        }
      })
      .catch(error => {
        setLoading(false);
        console.log(error);
        setSayimData([]);
        setSayimDataMain([]);
      });
  }


  const setFilter = (Param) => {
    setSayimArama(Param);
    setSayimData(SayimDataMain.filter(item => sc(item.MALZEME_STOK_NO, Param) || sc(item.MALZEME, Param) || sc(item.SURE, Param)))
  };


  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Container maxWidth="xl">
        <Card>
          <CardHeader title="Oasis Yönetimi Hareketsizlik Durum Raporu" />
          <Divider />
          <Backdrop className={classes.backdrop} open={Loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Snackbar open={uyari} autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={uyariKapat}>
            <Alert onClose={uyariKapat} severity={uyariTip}>
              {uyariAciklama || ''}
            </Alert>
          </Snackbar>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <Card className={classes.cardUstBolum}>
                  <CardHeader
                    title="İşlemler"
                    action={
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={6} >
                          <FormControl variant="outlined" className={classes.fields}>
                            <Typography variant="h6" component="h2">
                              <Select
                                variant="outlined"
                                fullWidth
                                native
                                value={Neden} onChange={handleNedenChange}
                              >
                                <option value="0">Seçim Yapınız...</option>
                                <option value="90">3 Ay Üstü</option>
                                <option value="180">6 Ay Üstü</option>
                                <option value="365">12 Ay Üstü</option>
                              </Select>
                            </Typography>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Button
                            variant="contained"
                            className={classes.button}
                            color="secondary"
                            endIcon={<SearchIcon></SearchIcon>}
                            onClick={onSorgula}
                          >
                            Sorgula
                          </Button>
                        </Grid>
                      </Grid>
                    }
                  />
                  <Divider />
                  <CardActions>
                    <Grid container spacing={1}>


                      <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                          <TextField
                            label="Arama Yapınız..."
                            value={SayimArama}
                            name={SayimArama}
                            className={clsx(classes.margin, classes.textField)}
                            onChange={event => { setFilter(event.target.value) }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <SearchIcon />
                                </InputAdornment>
                              )
                            }}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </CardActions>
                  <Divider />
                  <CardContent>
                    <TableContainer className={classes.container}>
                      <Table
                        className={classes.table}
                        size="small"
                        stickyHeader
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell padding='none' align="left">MalzemeStokNo</TableCell>
                            <TableCell padding='none' align="left">Malzeme</TableCell>
                            <TableCell padding='none' align="center">BirimKdvliFiyat</TableCell>
                            <TableCell padding='none' align="center">ToplamKdvliFiyat</TableCell>
                            <TableCell padding='none' align="left">Hareketsizlik Süresi</TableCell>
                            <TableCell padding='none' align="left">StokAdet</TableCell>

                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {SayimData.sort(
                            (
                              { isEditMode: previousID },
                              { isEditMode: currentID }
                            ) => previousID - currentID
                          )
                            // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => {
                              const labelId = `enhanced-table-checkbox-${index}`;
                              return (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={index}
                                >

                                  <TableCell
                                    align="left"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.MALZEME_STOK_NO}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    title={row.MALZEME}
                                    className={classes.tableCell}
                                  >
                                    {row.MALZEME}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    padding='none'
                                    title={row.KDVLI_FIYAT}
                                    className={classes.tableCell}
                                  >
                                    {row.KDVLI_FIYAT?.toFixed(2)} ₺
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    padding='none'
                                    title={row.TOPLAM_FIYAT}
                                    className={classes.tableCell}
                                  >
                                    {row.TOPLAM_FIYAT?.toFixed(2)} ₺
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.SURE}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.ADET}
                                  </TableCell>

                                </TableRow>
                              );
                            })}
                          <TableRow>
                            <TableCell
                              align="left"
                              padding='none'
                              className={classes.tableCell}
                            >
                            </TableCell>
                            <TableCell
                              align="right"
                              padding='none'
                              className={classes.tableCell}
                            >
                              <b>{"Genel Toplam"}</b>
                            </TableCell>
                            <TableCell
                              align="center"
                              padding='none'
                                 className={classes.tableCell}
                            >
                              <b>{BirimFiyatToplam?.toFixed(2)} ₺</b>
                            </TableCell>
                            <TableCell
                              align="center"
                              padding='none'
                              className={classes.tableCell}
                            >
                              <b> {ToplamFiyatToplam?.toFixed(2)} ₺</b>
                            </TableCell>
                            <TableCell
                              align="center"
                              padding='none'

                              className={classes.tableCell}
                            >
                      
                            </TableCell>
                            <TableCell
                              align="center"
                              padding='none'
                              className={classes.tableCell}
                            >
                     
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>

    </Page>
  );
}

export default StateOfInactivity;
